// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__ze_xI","addWidgetButton":"Header_addWidgetButton__1AxZy","dashboardTabs":"Header_dashboardTabs__Otg-I","active":"Header_active__1oyxh"};